import React from 'react';
import Loadable from 'react-loadable';

const LoadableWidget = Loadable({
  loader: () => import(/* webpackChunkName: "CasinoTopGamesWidget" */ './CasinoTopGamesWidget'),
  modules: ['./CasinoTopGamesWidget'],
  loading: () => <div />
});

export default LoadableWidget;
